import css from './styles.module.scss'

import CheckboxRow from '../CheckboxRow'
import Dropdown from '../Dropdown'
import SearchInputWithButton from '../SearchInputWithButton'
import { useState } from 'react'
import classnames from 'classnames/bind'

const cx = classnames.bind(css)

// ? facet example
// const facet = [
//   {
//     key: 'countries',
//     options: ['Australia'],
//     label: 'Countries',
//     multi: true,
//   },
// ]

const SearchSidebar = ({
  fullSearch,
  facets,
  facetFilters,
  setFilter,
  onSearchChange,
}) => {
  const [openDropDown, setOpenDropDown] = useState(false)
  const [visibleFilters, setVisibleFilters] = useState(true)

  function toggleFilters() {
    setVisibleFilters(!visibleFilters)
  }

  const hasCountriesFacet = facets.some((facet) => facet.key === 'countries')
  const facetsWithoutCountries = hasCountriesFacet
    ? facets.filter((facet) => facet.key !== 'countries')
    : facets
  const facetsCountries = hasCountriesFacet
    ? facets.filter((facet) => facet.key === 'countries')
    : []

  if (facetsCountries.length > 0) {
    facetsCountries[0].options.sort((a, b) => a.localeCompare(b))
  }

  const hasOptions = (facet) => {
    return facet.options && facet.options.length > 0
  }

  const isChecked = (currentSelected, option) => {
    return (
      currentSelected && currentSelected.some((item) => item.label === option)
    )
  }

  function toggleDropDown() {
    setOpenDropDown(!openDropDown)
  }
  return (
    <div className={css.sidebar}>
      <SearchInputWithButton
        fullSearch={fullSearch}
        onSearchChange={onSearchChange}
        toggleFilters={toggleFilters}
      />

      <div className={cx(css.facets, { [css.facetsHidden]: !visibleFilters })}>
        {facets.length > 0 &&
          facetsWithoutCountries.map((facet, id) => {
            const currentSelected = facetFilters[facet.key]
            if (facet.key === 'type') return null

            return (
              <div key={id}>
                <label className={css.facetsLabel}>{facet.label}</label>

                <ul className={css.options} role="listbox">
                  {hasOptions(facet) &&
                    facet.options.map((option, index) => {
                      return (
                        <CheckboxRow
                          key={index}
                          option={option}
                          isChecked={isChecked(currentSelected, option)}
                          onMouseDown={() => setFilter(facet.key, option)}
                        />
                      )
                    })}
                </ul>
              </div>
            )
          })}

        {facetsCountries && facetsCountries.length > 0 && (
          <Dropdown
            isOpen={openDropDown}
            onToggle={toggleDropDown}
            buttonLabel={facetsCountries[0].label}
          >
            {facetsCountries.map(
              (facet) =>
                hasOptions(facet) &&
                facet.options.map((option) => {
                  const currentSelected = facetFilters[facet.key]
                  if (facet.key === 'type') return null

                  return (
                    <CheckboxRow
                      key={option.slug}
                      option={option}
                      isChecked={isChecked(currentSelected, option)}
                      onMouseDown={() => setFilter(facet.key, option)}
                    />
                  )
                })
            )}
          </Dropdown>
        )}
      </div>
    </div>
  )
}

export default SearchSidebar
